import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/yujian_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  data: function data() {
    return {
      form: {
        id: "",
        flag: "",
        language: "",
        desc: ""
      },
      honorList: [],
      rules: {
        language: [{
          required: true,
          message: "请选择语言",
          trigger: "blur"
        }],
        desc: [{
          required: true,
          message: "请输入内容",
          trigger: "blur"
        }]
      }
    };
  },
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$refs.newPopover.open();

                if (data) {
                  _this.form = {
                    id: data.id,
                    flag: data.flag,
                    language: data.language,
                    desc: data.desc
                  };
                  _this.honorList = JSON.parse(data.desc);
                }

                _this.$nextTick(function () {
                  _this.honorList.forEach(function (item, index) {
                    _this.$refs['picUploadImage' + index][0].echos(item.pic);
                  });
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    addTime: function addTime() {
      this.honorList.push({
        content: "",
        pic: "",
        time: "",
        calender: [{
          content: "",
          time: ""
        }]
      });
    },
    addMonth: function addMonth(index) {
      this.honorList[index].calender.push({
        content: "",
        time: ""
      });
    },
    clearData: function clearData(id) {
      var _this2 = this;

      this.form = {
        id: this.form.id,
        flag: this.form.flag,
        language: this.form.language,
        desc: this.form.desc
      };
      this.honorList.forEach(function (item, index) {
        _this2.$refs['picUploadImage' + index][0].emptyFeil();
      });
      this.honorList = JSON.parse(this.form.desc);
      this.$refs.ruleForm.resetFields();
    },
    picUrl: function picUrl(e, index) {
      this.honorList[index].pic = e.toString();
    },
    submitData: function submitData() {
      var _this3 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          // let reqFn = this.form.id ? 'updWebDescriptions' : 'addWebDescriptions'
          var data = {
            id: _this3.form.id,
            flag: _this3.form.flag,
            language: _this3.form.language,
            desc: JSON.stringify(_this3.honorList)
          };

          _this3.$api.updWebDescriptions(data).then(function (res) {
            if (res.code == 0) {
              _this3.$message({
                message: '操作成功',
                type: 'success'
              });

              _this3.$refs.newPopover.hide();

              _this3.$emit('change');
            }
          });
        } else {
          return false;
        }
      });
    }
  }
};